import { QueryKeys } from "../queryKeys";
import { useQueryState } from "../useQueryState";
import { useStoreActions } from "../../../store/store-context";
export const useLegalTerms = function useLegalTerms() {
  let {
    refreshOnHookMount = false,
    withLoader = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    api
  } = useStoreActions();
  const {
    data: legalTerms,
    isLoading,
    isFetching
  } = useQueryState({
    queryKey: [QueryKeys.LegalTerms],
    queryFn: () => api.business.getLegalTerms(),
    refreshOnHookMount,
    withLoader
  });
  return {
    legalTerms: legalTerms !== null && legalTerms !== void 0 ? legalTerms : [],
    isLoading,
    isFetching
  };
};